
function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

class ProductTemplate extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {

      this.initMedias();

      if (this.querySelector('.product-info__toggle')) {
        this.initToggles();
      }

      if (this.querySelector('.product-collapse__container')) {

        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });
      }




      if (this.querySelector('.product-upsell__content')) {
        this.initUpsell();
      }

    }
  
    initUpsell() {

      document.querySelectorAll('.product-upsell__item-add [data-add-to-cart]').forEach((button) => {
          button.addEventListener('click', this.addToCartUpsell.bind(this));
      });

    }


    toggleFaqItem(e) {
      e.currentTarget
          .querySelector(".faq-close")
          .classList.toggle("faq-display-none");

      e.currentTarget.parentNode.classList.toggle("faq-item-active");

      const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
      console.log(item);



      item.slideToggle("250");

      if (item.closest('.product-collapse__revendeur-wraper')) {
          if (item.closest('.product-collapse__revendeur-wraper').classList.contains('active')) {
              this.swiperCollapse.autoplay.stop();
          } else {
              this.swiperCollapse.autoplay.start();
          }
      }
    }


    addToCartUpsell(event) {
      event.preventDefault();
      let target = event.target.closest('[data-add-to-cart]');
      if (!target) {
        console.error('No target with [data-add-to-cart] found.');
        return;
      }
    
      let variantId = Number(target.dataset.addToCart);
      if (!variantId) {
        console.error('Variant ID is missing or invalid:', variantId);
        return;
      }
    
      // Visual feedback: disable button + change text
      target.classList.add('adding');
      target.innerHTML = '<span class="p fw-7">Adding...</span>';
    
      const data = {
        items: [
          { id: variantId, quantity: 1 }
        ]
      };
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);
        // Visual feedback: show Added
        target.innerHTML = '<span class="p fw-7">Added!</span>';
        // Optional: delay a little before reloading
        setTimeout(() => {
          window.location.reload();
        }, 1200); // 1.2 seconds delay to let user see "Added!"
      })
      .catch(error => {
        console.error('Error:', error);
        target.innerHTML = '<span class="p fw-7">Failed</span>'; // If error, show something
        setTimeout(() => {
          target.innerHTML = '<span class="p fw-7">Add</span>'; // Reset button text
          target.classList.remove('adding');
        }, 2000);
      });
    }
    
    

    addToCart(event) {
      event.preventDefault();
      let form = event.target;
      let selections_items = [];

      if (this.querySelector('.product-info__reduction-wrapper.active input:checked')) {
          selections_items.push({
              id: Number(form.querySelector('input[name="id"]').value),
              quantity: Number(this.querySelector('.product-info__reduction-wrapper.active input').dataset.productQuantity),
          })
      } else {
          selections_items.push({
              id: Number(form.querySelector('input[name="id"]').value),
              quantity: 1,
          })
      }

      const data = {
          items: selections_items
      }

      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
          .then(response => response.json())
          .then(data => {
              console.log('Success:', data);
          })

    }


    initMedias() {
      this.swiperThumb = new Swiper(this.querySelector('.thumb-carrousel'), {
          // Optional parameters
          direction: 'horizontal',
          slidesPerView: "auto",
          spaceBetween: 5,
          threshold: 5,
          breakpoints: {
              990: {
                  spaceBetween: 0,
              },
          },
      });

      this.swiper = new Swiper(this.querySelector('.main-carrousel'), {
          direction: 'horizontal',
          slidesPerView: "auto",
          spaceBetween: 10,
          thumbs: {
              swiper: this.swiperThumb,
              slideThumbActiveClass: 'swiper-slide-thumb-active',
          },
          navigation: {
              nextEl: this.querySelector('.main-carrousel .swiper-button-next'),
              prevEl: this.querySelector('.main-carrousel .swiper-button-prev'),
          },
      });
  }


    initUpsell() {
      this.swiperUpsell = new Swiper(this.querySelector('.product-upsell__content'), {
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
              nextEl: this.querySelector('.product-upsell__header .swiper-button-next'),
              prevEl: this.querySelector('.product-upsell__header .swiper-button-prev'),
          },
          pagination: {
              el: this.querySelector('.product-upsell__header .swiper-pagination'),
              clickable: true,
          },
      });

      document.querySelectorAll('.product-upsell__item-add [data-add-to-cart]').forEach((button) => {
          button.addEventListener('click', this.addToCartUpsell.bind(this));
      });

  }



    initToggles() {
      this.querySelectorAll('.product-info__toggle-title').forEach((toggleTitle) => {
        toggleTitle.addEventListener('click', () => {
          let toggleData = toggleTitle.dataset.toggle;
          let toggleContent = this.querySelector(`.product-info__toggle-content[data-toggle="${toggleData}"]`);
  
          this.querySelectorAll('.product-info__toggle-content').forEach((content) => {
            content.classList.remove('active');
          });
  
          this.querySelectorAll('.product-info__toggle-title').forEach((title) => {
            title.classList.remove('active');
          });
  
          toggleContent.classList.add('active');
          toggleTitle.classList.add('active');
        });
      });
    }
  }
  
  // Register the custom element
  customElements.define('product-template', ProductTemplate);
  